import { Subject } from 'rxjs';

import type { TeamingRequest } from 'features/rns/interfaces';

export class TeamingCallEventBus {
  static $newCall = new Subject<TeamingRequest>();
  static $showContent = new Subject<void>();
}
